import React from "react";
import { Avatar, Box, Chip, Link, Stack, Typography } from "@mui/material";

const ExperienceCard = ({ experience, index }) => (
  <Box className="tactical-border cyber-clip" sx={{ p: { xs: 3, md: 4 }, bgcolor: "rgba(5, 8, 18, 0.85)" }}>
    <Stack direction={{ xs: "column", md: "row" }} spacing={3} alignItems={{ xs: "flex-start", md: "center" }}>
      <Avatar src={experience.img} variant="square" sx={{
        width: 64, height: 64, bgcolor: "rgba(0, 240, 255, 0.05)",
        border: "1px solid rgba(0, 240, 255, 0.15)",
        clipPath: "polygon(10px 0, 100% 0, 100% calc(100% - 10px), calc(100% - 10px) 100%, 0 100%, 0 10px)",
      }} />
      <Stack spacing={0.5} flex={1}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontFamily: "'Inter', sans-serif", fontWeight: 400, fontSize: "1.4rem", color: "#e6e8ec" }}>
            {experience.role}
          </Typography>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#858d99", letterSpacing: "0.15em" }}>
            [{experience.date}]
          </Typography>
        </Stack>
        <Typography className="sys-glitch" sx={{ color: "#00f0ff", fontSize: "0.9rem", fontFamily: "'JetBrains Mono', monospace", letterSpacing: "0.05em", width: "fit-content", transition: "all 0.3s" }}>
          @ {experience.company}
        </Typography>
      </Stack>
    </Stack>
    
    {experience.desc && (
      <Typography sx={{ color: "#858d99", mt: 3, fontSize: "0.9rem", lineHeight: 1.8 }}>
        {experience.desc}
      </Typography>
    )}
    
    {experience.skills && (
      <Stack direction="row" flexWrap="wrap" gap={1} mt={3}>
        {experience.skills.map((s) => (
          <Chip key={s} label={s} size="small" sx={{
            bgcolor: "rgba(0, 240, 255, 0.02)", color: "#e6e8ec",
            border: "1px solid rgba(0, 240, 255, 0.1)", borderRadius: 0, fontSize: "0.7rem",
            fontFamily: "'JetBrains Mono', monospace",
            clipPath: "polygon(5px 0, 100% 0, 100% calc(100% - 5px), calc(100% - 5px) 100%, 0 100%, 0 5px)",
          }} />
        ))}
      </Stack>
    )}
    
    {experience.doc && (
      <Link href={experience.doc} target="_blank" underline="hover"
        sx={{ mt: 3, display: "inline-flex", color: "#00f0ff", fontSize: "0.8rem", fontFamily: "'JetBrains Mono', monospace" }}>
        [ACCESS_CREDENTIAL]
      </Link>
    )}
  </Box>
);

export default ExperienceCard;
